const ROUTES = {
  HOME_PAGE: '/',
  LOGIN: '/login',
  LOGOUT: '/logout',
  PRIVACY_POLICY: '/privacy',
  //CONFIRM_EMAIL: 'confirm',
  //FORGOT_PASSWORD: 'reset_password', // pragma: allowlist secret
  // FORGOT_PASSWORD_VERIFICATION: 'verification', // pragma: allowlist secret
  SELECT_EVENT: '/events',
  EXTERNAL_EVENT: '/events/external',
  EVENT_PAGE: (eventId = ':eventId') => `/events/${eventId}`,
  SELECT_AVATAR_PROVIDER: (eventId = ':eventId') =>
    `/events/${eventId}/avatars`,
  SELECT_USER_AVATAR: (eventId = ':eventId') => `/events/${eventId}/my-avatars`,
  SELECT_AVATURN: (eventId = ':eventId') =>
    `/events/${eventId}/avatars/avaturn`,
  AVATURN: (eventId = ':eventId') => `/events/${eventId}/avaturn`,
  CUSTOM_AVATURN: '/avaturn/custom-avaturn',
  CUSTOM_AVATURN_ON_MOBILE: (eventId = ':eventId') =>
    `/events/${eventId}/avaturn/custom-avaturn`,
  SELECT_AVATAR_SKIN: (eventId = ':eventId') =>
    `/events/${eventId}/avatar-skins`,
  DEVICES_TEST: (eventId = ':eventId') => `/events/${eventId}/devices`,
  READY_PLAYER: (eventId = ':eventId') => `/events/${eventId}/ready-player-me`,

  GAME_TUTORIAL: '/tutorial',
  //CONFIRMED_EMAIL: 'confirmed',
  //CONFIRM_EVENT: 'event_subscribe',
  //RECOVER_PASSWORD: 'recovery', // pragma: allowlist secret

  //TRY_DEMO: 'try_demo',
};

export default ROUTES;
